<template>
    <div class="otp-input d-block text-center justify-content-center">
        <input autocomplete="false" v-for="(item, index) in textArr" :ref="'input_text_' + index" :key="index" class="otp" type="text" @keyup="changeValue($event, index)" maxlength=1>
    </div>
</template>

<script>
export default {
    data() {
        return {
            textArr: [],
            result: ''
        }
    },
    props: {
        text: String
    },
    created () {
        this.textArr = this.text.split('')
    },
    methods: {
        changeValue(event, index) {
            if (event.target.value == '') {
                console.log(event)
            }
            if ((event.keyCode == 8 && index > 0 || event.keyCode == 37)) {
                this.$nextTick(() => this.$refs[`input_text_${index - 1}`][0].focus())
            }
            if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90) && index < this.textArr.length - 1 || event.keyCode == 39) {
                this.$nextTick(() => this.$refs[`input_text_${index + 1}`][0].focus())
            }
            if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90) || event.keyCode == 8) {
                this.$refs[`input_text_${index}`][0].value = event.key
                if (event.keyCode == 8) {
                    this.$refs[`input_text_${index}`][0].value = ''
                }
            }

            this.inputToText()
            this.$emit('input', this.result)
        },
        inputToText () {
            this.result = ''
            for (let index = 0; index < this.textArr.length; index++) {
                this.result += this.$refs[`input_text_${index}`][0].value
            }
        }
    },
    watch: {
    }
    
}
</script>

<style>

.otp-input input {
    display: inline-block;
    width: 45px;
    height: 45px;
    text-align: center;
    margin: 2px;
    border: 1px solid #000;
    border-radius: 4px;
    font-family: 'iCiel Crocante';
    font-size: 2rem;
}
</style>